import React from "react";

const mapStyles = {
  flexGrow: 1,
  height: "100%",
  overflow: "none",
  position: "relative",
  width: "100%",
};

const Map = React.forwardRef(function Map({ children }, ref) {
  return (
    <section id="public-map" ref={ref} style={mapStyles}>
      {children}
    </section>
  );
});

export default Map;
